import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from '../service/env/env.service';
import { Bank, BankPageResponse, BankSingleResponse } from './bank.model';

@Injectable({
  providedIn: 'root'
})
export class BankService {

  private baseUrl: string;

  constructor(private http: HttpClient, private env: EnvService) {
    this.baseUrl = this.env.apiUrl + '/bank';
  }

  /**
   * GET /bank?page=&size=&bankName=
   * Fetches a paginated list of banks, optionally filtered by name.
   */
  getAllBanks(page: number = 0, size: number = 10, bankName?: string): Observable<BankPageResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (bankName && bankName.trim()) {
      params = params.set('bankName', bankName.trim());
    }

    return this.http.get<BankPageResponse>(this.baseUrl, { params });
  }

  /**
   * GET /bank/:id
   * Fetches a single bank by ID.
   */
  getBankById(id: number): Observable<BankSingleResponse> {
    return this.http.get<BankSingleResponse>(`${this.baseUrl}/${id}`);
  }

  /**
   * POST /bank
   * Creates a new bank.
   */
  createBank(bank: Bank): Observable<BankSingleResponse> {
    const payload = {
      bankName: bank.bankName,
      contactPersonName: bank.contactPersonName,
      contactPersonEmail: bank.contactPersonEmail,
      contactPersonPhone: bank.contactPersonPhone,
      bankLogoUrl: bank.bankLogoUrl || ''
    };

    return this.http.post<BankSingleResponse>(this.baseUrl, payload);
  }

  /**
   * PUT /bank/:id
   * Updates an existing bank.
   */
  updateBank(id: number, bank: Bank): Observable<BankSingleResponse> {
    const payload = {
      bankName: bank.bankName,
      contactPersonName: bank.contactPersonName,
      contactPersonEmail: bank.contactPersonEmail,
      contactPersonPhone: bank.contactPersonPhone,
      bankLogoUrl: bank.bankLogoUrl || ''
    };

    return this.http.put<BankSingleResponse>(`${this.baseUrl}/${id}`, payload);
  }

  /**
   * DELETE /bank/:id
   * Soft-deletes a bank.
   */
  deleteBank(id: number): Observable<BankSingleResponse> {
    return this.http.delete<BankSingleResponse>(`${this.baseUrl}/${id}`);
  }
}
